import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonService } from '../../../../services/common/common.service';
import { VaultService } from '../../../services/vault.service';
import { AbstractControl, Form, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-vault-pay-addupdate',
  templateUrl: './vault-pay-addupdate.component.html',
  styleUrl: './vault-pay-addupdate.component.scss'
})
export class VaultPayAddupdateComponent implements OnInit, OnChanges, OnDestroy {
  @Input() vaultPayData: any;
  @Input() context: string = '';
  @Output() changeModalStatus: EventEmitter<any> = new EventEmitter<any>();

  vaultPayForm: FormGroup = this.fb.group({});
  Submitted: boolean = false;
  receiverList: any[] = [];
  clientList: any[] = [];
  currentTransRefType: string = '';
  currentSubTransRefType: string = '';

  maxDate: Date = new Date();
  constructor(public fb: FormBuilder, private vaultPayService: VaultService, public commonService: CommonService) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(): void {
    if (this.vaultPayData) {
      this.receiverList = this.vaultPayData?.usersList || [];
    }
  }

  setReceiverData(receiver: any) {
    //Reset TransRefType and TransRefTypeId when receiver changes
    this.currentTransRefType = '';
    this.vaultPayForm.controls['transRefTypeId'].setValue(null);

    this.vaultPayForm.patchValue({
      accountId: receiver.id
    });
  }

  initializeForm() {
    this.vaultPayForm = this.fb.group({
      accountId: [this.vaultPayData?.currentRecord ? this.vaultPayData?.currentRecord?.accountId : null, Validators.required],
      transDate: [this.vaultPayData?.currentRecord?.transDate ? this.vaultPayData?.currentRecord?.transDate : null, Validators.required],
      amount: [this.vaultPayData?.currentRecord?.amount ? this.vaultPayData?.currentRecord?.amount : null, Validators.required],
      transRefType: [this.vaultPayData.currentRecord?.transRefType ? this.vaultPayData?.currentRecord?.transRefType : null, Validators.required],
      transRefTypeId: [this.vaultPayData.currentRecord?.transRefTypeId ? this.vaultPayData?.currentRecord?.transRefTypeId : null],
    });
  }


  toggleTransRefType(event: any) {
    this.currentSubTransRefType = event.checked ? 'Booking' : 'Allotment';
  }

  getClientBookingAllotmentList() {

  }


  onSubmit() { }


  closePaymentDialogue() {
    this.changeModalStatus.emit({ context: this.context, showaddUpdateModal: false, isSubmitted: false });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.vaultPayForm.controls;
  }

  ngOnDestroy(): void {

  }
}
